import React, { useEffect, useState } from 'react';


const ServicesPage = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); 

  const services = [
    { title:'Web Development', desc:'Modern, scalable web apps with first engineering.', bullets:['React/Next.js','Node & APIs','CMS & Headless','Performance & SEO'] },
    { title:'Mobile Development', desc:'Cross‑platform apps with native feel and reliability.', bullets:['React Native','Fast Iteration','Store Readiness','Analytics'] },
    { title:'UI/UX Design', desc:'Accessible, delightful interfaces that drive adoption.', bullets:['Research','Wireframes','Prototypes','Design Systems'] },
    { title:'Cloud & DevOps', desc:'Secure, observable, and automated infrastructure and performance engineering.', bullets:['AWS/Azure','CI/CD','IaC','Monitoring'] },
    { title:'Quality Assurance', desc:'Automation and performance testing baked into delivery and well defined testing strategies.', bullets:['E2E Automation','Performance','Security','Release Readiness'] },
    { title:'Data & Analytics', desc:'Turn data into insights and decisions with robust pipelines and BI.', bullets:['ETL/ELT','Warehousing','Dashboards','ML Readiness'] },
  ];

  const process = [
    { step:'01', title:'Discover', desc:'Define goals, risks, success metrics, and roadmap.' },
    { step:'02', title:'Design', desc:'Translate requirements into flows, prototypes, and UI.' },
    { step:'03', title:'Build', desc:'Ship in small increments with CI/CD and code quality.' },
    { step:'04', title:'Scale', desc:'Observe, optimize, and evolve with real user feedback.' },
  ];

  // Industries tabs data and state
  const industries = [
    {
      name: 'E‑commerce',
      description: 'High-converting storefronts & checkout optimization.',
      image: "./ecommerce2.jpg",
    },
    {
      name: 'Fintech',
      description: 'Secure onboarding, payments & real-time data for finance.',
      image: './Fintech.jpg',
    },
    {
      name: 'Healthcare',
      description: 'Patient portals, telemedicine, and privacy-first data workflows.',
      image: './Healthcare.jpg',
    },
    {
      name: 'SaaS',
      description: 'Multi-tenant platforms, billing, and product analytics at scale.',
      image: './SaaS.jpg',
    },
    {
      name: 'Education',
      description: 'LMS integrations, content delivery, and collaborative learning tools.',
      image: './Education.jpg',
    },
    {
      name: 'Logistics',
      description: 'Tracking, routing, and operational dashboards for supply chains.',
      image: './Logistics.jpg',
    },
    {
      name: 'Management Dashboard',
      description: 'Centralized platform for monitoring, analytics and task management softwares.',
      image: './Dashboard.avif',
    },
    
  ];
  const [activeIndustryIndex, setActiveIndustryIndex] = useState(0);
  const activeIndustry = industries[activeIndustryIndex];

  return (
    <main className="pt-20 bg-white dark:bg-gray-900 min-h-screen">
      {/* Hero */}
      <section className="relative">
        <div className="max-w-7xl mx-auto px-4 py-12 md:py-16">
          <h1 className="text-3xl md:text-5xl font-bold text-gray-900 dark:text-white">Services for Every Stage</h1>
          <p className="mt-3 md:text-lg text-gray-600 dark:text-gray-300 max-w-3xl">From discovery to scale, Codepact partners with you to build resilient products users love.</p>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-300 dark:via-primary-600 to-transparent"></div>
      </section>

      {/* Capabilities */}
      <section className="py-12 md:py-16 bg-blue-50 dark:bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <div key={i} className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow border border-gray-200/50 dark:border-gray-700/50">
              <div className="w-12 h-12 rounded-xl bg-[#0284c7] text-white flex items-center justify-center font-bold">{i+1}</div>
              <h3 className="mt-4 text-lg font-semibold text-gray-900 dark:text-white">{s.title}</h3>
              <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">{s.desc}</p>
              <ul className="mt-4 grid grid-cols-2 gap-2 text-xs text-gray-600 dark:text-gray-300">
                {s.bullets.map((b, bi) => (
                  <li key={bi} className="flex items-center gap-2"><span className="w-1.5 h-1.5 bg-[#0284c7] rounded-full"></span>{b}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* Section Divider */}
      <div className="px-4">
        <div className="max-w-7xl mx-auto h-px bg-gradient-to-r from-transparent via-primary-300 dark:via-primary-600 to-transparent"></div>
      </div>

      {/* Process */}
      <section className="py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white text-center">A Practical Delivery Process</h2>
          <div className="mt-10 grid md:grid-cols-4 gap-6">
            {process.map((p, i) => (
              <div key={i} className="bg-blue-50 dark:bg-gray-800 rounded-2xl p-6 border border-gray-200 dark:border-gray-700 shadow">
                <div className="text-sm font-semibold text-[#0284c7]">{p.step}</div>
                <h3 className="mt-2 font-semibold text-gray-900 dark:text-white">{p.title}</h3>
                <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>


        {/* Section Divider */}
        <div className="px-4">
        <div className="max-w-7xl mx-auto h-px bg-gradient-to-r from-transparent via-primary-300 dark:via-primary-600 to-transparent"></div>
      </div>

       {/* Industries (Tabs + Preview) */}
       <section className="py-8 md:py-10">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white text-center">Industries We Serve</h2>

          <div className="sm:col-span-2 rounded-2xl overflow-hidden border block md:hidden mt-6 border-gray-200 dark:border-gray-700 shadow bg-gray-100 dark:bg-gray-900">
                <img src={activeIndustry.image} alt={activeIndustry.name} className="w-full md:h-[360px] h-[220px] object-cover" />
              </div>
          <div className="mt-8 grid lg:grid-cols-3 gap-6 items-start">
            {/* Tabs (left) */}
            <div className="lg:col-span-1 bg-white dark:bg-gray-800 rounded-2xl p-2 border border-gray-200 dark:border-gray-700 shadow">
              <div className="divide-y divide-gray-200 dark:divide-gray-700">
                {industries.map((item, i) => (
                  <button
                    key={item.name}
                    onClick={() => setActiveIndustryIndex(i)}
                    className={`w-full text-left px-4 py-3 transition ${
                      i===activeIndustryIndex
                        ? 'bg-primary-50 dark:bg-primary-900/20 text-[#0284c7] dark:text-primary-300'
                        : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700/40'
                    }`}
                  >
                    <div className="font-semibold">{item.name}</div>
                    <div className="text-xs text-gray-500 dark:text-gray-400">{item.description}</div>
                  </button>
                ))}
              </div>
            </div>

            {/* Preview (right) */}
            <div className="lg:col-span-2 grid sm:grid-cols-2 gap-6">
              <div className="sm:col-span-2 rounded-2xl overflow-hidden border md:block hidden border-gray-200 dark:border-gray-700 shadow bg-gray-100 dark:bg-gray-900">
                <img src={activeIndustry.image} alt={activeIndustry.name} className="w-full md:h-[360px] h-[220px] object-cover" />
              </div>
              <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 border border-gray-200 dark:border-gray-700 shadow">
                <div className="text-sm font-semibold text-[#0284c7]">{activeIndustry.name}</div>
                {/* <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">{activeIndustry.description}</p> */}
                <ul className="mt-4 space-y-2 text-xs text-gray-600 dark:text-gray-300">
                  {['Discovery workshop','Solution blueprint','Pilot and iterate'].map((p, idx) => (
                    <li key={idx} className="flex items-center gap-2"><span className="w-1.5 h-1.5 bg-[#0284c7] rounded-full"></span>{p}</li>
                  ))}
                </ul>
              </div>
              <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 border border-gray-200 dark:border-gray-700 shadow">
                <div className="text-sm font-semibold text-[#0284c7]">Outcomes</div>
                <ul className="mt-2 space-y-2 text-xs text-gray-600 dark:text-gray-300">
                  {['Faster time-to-value','Measurable KPIs','Scalable foundations'].map((p, idx) => (
                    <li key={idx} className="flex items-center gap-2"><span className="w-1.5 h-1.5 bg-[#0284c7] rounded-full"></span>{p}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Engagement Models */}
      <section className="py-8 md:py-10 bg-gray-100 dark:bg-gray-800/40">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white text-center">Engagement Models</h2>
          <div className="mt-10 grid md:grid-cols-3 gap-6">
            {[
              {title:'Fixed Scope',desc:'Clear deliverables with agreed timeline and budget—great for MVPs.'},
              {title:'Time & Material',desc:'Flexible scope with velocity-based planning for evolving needs.'},
              {title:'Dedicated Squad',desc:'Cross‑functional team embedded with your product organization.'}
            ].map((m, i) => (
              <div key={i} className="bg-white dark:bg-gray-900 rounded-2xl p-6 border border-gray-200 dark:border-gray-700 shadow">
                <h3 className="font-semibold text-gray-900 dark:text-white">{m.title}</h3>
                <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">{m.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

     

      {/* CTA */}
      <section className="pb-8 md:pb-10 bg-gray-100 dark:bg-gray-800/40">
        <div className="max-w-7xl mx-auto px-4">
          <div className="rounded-2xl p-8 md:p-10 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 shadow">
            <div className="md:flex items-center justify-between gap-6">
              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 dark:text-white">Bring your next idea to life</h3>
                <p className="mt-2 text-gray-600 dark:text-gray-300">Tell us your goals—We’ll propose timelines, scope, and a clear path to value.</p>
              </div>
              <a href="/contact" className="mt-4 md:mt-0 inline-block bg-[#0284c7] hover:bg-[#0271a3] text-white px-6 py-3 rounded-lg font-semibold transition">Start a project</a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ServicesPage;


